<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QP4sFE/tc-custom/9781514005477.jpg?1696024361779" alt="This image is the cover for the book From Prisoner to Prince, New Studies in Biblical Theology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Prisoner to Prince, New Studies in Biblical Theology
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>The story of Joseph is prominent in the book of Genesis and yet is rarely mentioned in the rest of Scripture.</strong> How then do we understand Joseph's significance in redemptive history? When Christians have addressed this question, the conversation has frequently turned toward typology: Is Joseph a type of the Messiah?</p> <p>Messianic interpretations of the Joseph narrative have often lacked methodological rigor or have simply failed to make a convincing case. Most often interpreters have simply noted historical correspondences between Joseph and Jesus, without considering the narrative's function in the context of Genesis, its redemptive-historical significance, or its appropriation by later biblical authors.</p> <p>In this New Studies in Biblical Theology volume, Samuel Emadi offers a more comprehensive canonical treatment of the Joseph narrative. He considers Genesis 37–50 in its own literary and theological context, intra-canonical development of the Joseph story via inner-biblical allusion, and New Testament references and allusions. Emadi defends the notion that Joseph functions as the resolution to the plot of Genesis and that this story typologically influences how later biblical authors narrate redemptive history, culminating in the New Testament's portrayal of Jesus as an antitypical, new and final Joseph.</p> <p>Addressing key issues in biblical theology, the works comprising New Studies in Biblical Theology are creative attempts to help Christians better understand their Bibles. The NSBT series is edited by D. A. Carson, aiming to simultaneously instruct and to edify, to interact with current scholarship and to point the way ahead.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Samuel Emadi, D. A. Carson
      </h2>
      
      <p class="authorDescription body article"><p>Samuel Emadi (PhD, The Southern Baptist Theological Seminary) serves as the senior pastor at Hunsinger Lane Baptist Church in Louisville, Kentucky, and as an editor at 9Marks.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Apollos
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ae256b5